import request from '@/utils/request'
const platform = localStorage.getItem('platform')

export function getLoginDevices(data) {
    return request.get(`/${platform}/login_devices`, data)
}

export function deleteLoginDevices(ids) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/login_devices/${ids}`)
}
